import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-new-password',
  templateUrl: './forgot-new-password.component.html',
  styleUrls: ['./forgot-new-password.component.scss']
})
export class ForgotNewPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
